<template>
  <div>
    <b-modal
      id="error-modal"
      ref="modal"
      title=""
      hide-footer
      hide-header
      centered
    >
      <div class="header">
        <span class="close-icon"
              @click="$bvModal.hide('error-modal')">
          <img src="@/assets/svg/close.svg"
               aria-label="close">
        </span>

        <h3>
          Ошибка! <br><br>
        </h3>

        <div class="text">
          {{ errorText }}
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  export default {
    props: ['errorText'],

    data() {
      return {
      }
    },

    methods: {
    }
  }
</script>

<style scoped lang="scss">
.header {
  flex-direction: column;
  width: 100%;

  .close-icon {
    float: right;
    cursor: pointer;
    transition: .4s all;
    margin-right: 5px;

    &:hover {
      opacity: .85;
    }
  }

  h3 {
    width: 100%;
    margin-top: 50px;
    margin-bottom: 30px;
    font-weight: 800;
    font-family: $regular;
    font-size: 18px;
    text-transform: uppercase;
    text-align: center;
  }
}

.text {
  color: white;
  font-size: 16px;
}
</style>
